export const LOCAL_STORAGE = {
  languageBannerDismissed: "language-banner-dismissed",
  languageSelected: "language-picker-selected",
};
